import { reemaColors } from '../styles/colors';
import type { BackgroundStyles } from './infoCard.types';

/**
 * Gets the background value for an info card background style.
 * @param backgroundStyle - The semantic background style to render.
 * @returns CSS background value for the style, or undefined for the default card surface.
 */
export function getInfoCardBackground(backgroundStyle: BackgroundStyles) {
  if (backgroundStyle === 'shadow') {
    return '#e7f0f4';
  }
  if (backgroundStyle === 'start') {
    return reemaColors.primaryContainer;
  }
  if (backgroundStyle === 'completed') {
    return reemaColors.successBackground;
  }
  if (backgroundStyle === 'unscheduled') {
    return reemaColors.removedBackground;
  }
  return undefined;
}
